export const SORT_TYPE = {
  DEFAULT: 'DEFAULT',
  UP: 'UP',
  DOWN: 'DOWN',
}
export const DISCOUNT_TYPE = {
  UNDEFINED: 'undefined',
  AMOUNT: 'amount',
  PERCENTAGE: 'percentage',
}

export const DISCOUNT_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
}

export const AWARD_LEVELS = ['Organisation', 'Season', 'Competition', 'Division', 'Pool', 'Stage', 'Round', 'Fixture']

export const RECIPIENT_TYPES = ['Team', 'Player']

export const ALLOCATION_TYPES = ['Manual. Voting', 'Statistics', 'Competition Final Standing']

export const RESULT_BASES = ['Highest Number', 'Lowest Number']

export const FORM_BUILDER = {
  PRODUCTS: 'products',
  SETTINGS: 'settings',
  TEST_AND_PUBLISH: 'testAndPublish',
  MESSAGING_AND_NOTIFICATIONS: 'messagingAndNotifications',
  DISTRIBUTE: 'distribute',
  QUESTIONS_AND_LAYOUT: 'questionsAndLayout',
}
export const COMPETITION = {
  ADD_TEAMS: 'addTeams',
}
export const ParticipantsAgeStartEndOption = [
  {
    key: 'ParticipantsOption',
    value: [
      {
        id: '',
        name: '--None--',
      },
      {
        id: 'Season Start Date',
        name: 'Season Start Date',
      },
      {
        id: 'Season End Date',
        name: 'Season End Date',
      },
      {
        id: 'Specific Date',
        name: 'Specific Date',
      },
    ],
    key_prefix: '',
  },
]
/**
 * Questions Type
 */
export const QUESTION_TYPES = {
  text: 'Text',
  picklist: 'Picklist',
  multiPicklist: 'multiPicklist',
  calender: 'Date',
  checkBox: 'Checkbox',
  termsAndConditions: 'TermsAndConditions',
  number: 'Number',
  sectionBreak: 'Section Break',
  radioButton: 'Radio button',
  emailAddress: 'Email address',
  displayOnly: 'Display Only',
  imageUpload: 'Image Upload',
  multiMemberType: 'MultiMemberType',
  user: 'User',
}
export const GENDER_TYPES = {
  male: 'Male',
  female: 'Female',
  mixed: 'Both',
}

export const ORDER_STATUS = {
  COMMITTED: 'Committed',
  PAID: 'Paid',
  REFUNDED: 'Refunded',
  CANCELED: 'Canceled',
}

export const ORGANISATION_TYPE = {
  state: 'State',
  club: 'Club',
  national: 'National',
}

export const PREFERRED_LANGUAGE = {
  value: [
    {
      id: '',
      name: '--None--',
    },
    {
      id: 'English',
      name: 'English',
    },
    {
      id: 'Italian',
      name: 'Italian',
    },
    {
      id: 'German',
      name: 'German',
    },
    {
      id: 'Mandarin',
      name: 'Mandarin',
    },
    {
      id: 'Dutch',
      name: 'Dutch',
    },
    {
      id: 'Korean',
      name: 'Korean',
    },
    {
      id: 'Other',
      name: 'Other',
    },
  ],
  key_prefix: '',
}

export const OCCUPATION = {
  value: [
    {
      id: '',
      name: '--None--',
    },
    {
      id: 'Engineering Manager',
      name: 'Engineering Manager',
    },
    {
      id: 'Taxation Accountant',
      name: 'Taxation Accountant',
    },
    {
      id: 'Civil Engineer',
      name: 'Civil Engineer',
    },
    {
      id: 'Medical Laboratory Scientist',
      name: 'Medical Laboratory Scientist',
    },
    {
      id: 'Podiatrist',
      name: 'Podiatrist',
    },
    {
      id: 'Student',
      name: 'Student',
    },
    {
      id: 'Teacher',
      name: 'Teacher',
    },
    {
      id: 'Manager',
      name: 'Manager',
    },
    {
      id: 'Accountant',
      name: 'Accountant',
    },
    {
      id: 'Other',
      name: 'Other',
    },
  ],
  key_prefix: '',
}

export const ETHNICITY = {
  value: [
    {
      id: '',
      name: '--None--',
    },
    {
      id: 'Australian',
      name: 'Australian',
    },
    {
      id: 'English',
      name: 'English',
    },
    {
      id: 'Irish',
      name: 'Irish',
    },
    {
      id: 'Scottish',
      name: 'Scottish',
    },
    {
      id: 'Italian',
      name: 'Italian',
    },
    {
      id: 'German',
      name: 'German',
    },
    {
      id: 'Chinese',
      name: 'Chinese',
    },
    {
      id: 'Indian',
      name: 'Indian',
    },
    {
      id: 'Greek',
      name: 'Greek',
    },
    {
      id: 'Dutch',
      name: 'Dutch',
    },
    {
      id: 'Other',
      name: 'Other',
    },
  ],
  key_prefix: '',
}

export const ABORIGINAL_ORIGIN = {
  value: [
    {
      id: '',
      name: '--None--',
    },
    {
      id: 'Yes',
      name: 'Yes',
    },
    {
      id: 'No',
      name: 'No',
    },
    {
      id: 'Do Not Wish to Disclose',
      name: 'Do Not Wish to Disclose',
    },
  ],
}

export const PUBLIC_VISIBILITY = {
  value: [
    {
      id: '',
      name: '--None--',
    },
    {
      id: 'Hidden',
      name: 'Hidden',
    },
    {
      id: 'Visible',
      name: 'Visible',
    },
    {
      id: 'Alias Only',
      name: 'Alias Only',
    },
  ],
}
